import React, { useRef, useState } from "react"
import { FormWrapper, TextField, Button, InputSelect, InputCheckbox } from "@shared"
import { css } from "@jsUtils"
import * as Yup from "yup"
import { CONTENT, CONSTANTS } from "@data"

import axios from "axios"
import Styles from "../ContactForm/contactForm.module.scss"

const { SUBMIT } = CONSTANTS
const { CONTACT } = CONTENT

const listOfRoles = [
  {
    value: "Accounts Payable",
    label: "Accounts Payable"
  },
  {
    value: "Clinician",
    label: "Clinician"
  },
  {
    value: "Director/Department Head",
    label: "Director/Department Head"
  },
  {
    value: "Distributor",
    label: "Distributor"
  },
  {
    value: "Executive",
    label: "Executive"
  },
  {
    value: "Hospital Administration",
    label: "Hospital Administration"
  },
  {
    value: "Hospital IT",
    label: "Hospital IT"
  },
  {
    value: "Investor",
    label: "Investor"
  },
  {
    value: "Purchasing",
    label: "Purchasing"
  },
  {
    value: "Other",
    label: "Other"
  }
]

const fieldValidation = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string()
    .email("Invalid email address!")
    .required("Required"),
  phoneNumber: Yup.string(),
  company: Yup.string().required("Required"),
  role: Yup.string().required("Required"),
  message: Yup.string(),
  isSignUp: Yup.string()
})

const preparePayload = userInput => {
  console.log(userInput)
  const payload = JSON.stringify({
    submittedAt: new Date().getTime(),
    fields: [
      {
        name: "email",
        value: userInput.email
      },
      {
        name: "phone",
        value: userInput.phoneNumber
      },
      {
        name: "firstname",
        value: userInput.firstName
      },
      {
        name: "lastname",
        value: userInput.lastName
      },
      {
        name: "what_best_describes_your_role_",
        value: userInput.role
      },
      {
        name: "company",
        value: userInput.company
      },
      {
        name: "message",
        value: userInput.message
      },
      {
        name: "sign_up_for_our_newsletter",
        value: userInput.isSignUp
      }
    ],
    context: {
      pageUri: "subscribe-success",
      pageName: "Subscribe successful"
    }
  })
  return payload
}

const initVals = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  company: "",
  role: listOfRoles[0].value,
  message: "",
  isSignUp: false
}

const EventForm = props => {
  const { className, theme, color, inputVariant, inputStyle, hoverColor, returnSuccess } = props
  const formTop = useRef()
  const [success, setSuccess] = useState(SUBMIT.IDLE)

  const onSubmit = (userInput, { setSubmitting }) => {
    setSuccess(SUBMIT.BUSY)

    const data = preparePayload(userInput)
    const portalId = "20465501"
    const formId = "112ef883-fa9b-42bc-bf3e-d393f3a77872"

    return axios({
      url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.parse(data)
    })
      .then(result => {
        console.log(result)
        setSubmitting(false)
        returnSuccess(true)
        setSuccess(SUBMIT.SUCCESS)
      })
      .catch(() => {
        setSuccess(SUBMIT.FAIL)
      })
  }

  return (
    <div ref={formTop} className={css(Styles.wrapper, className)}>
      <FormWrapper initVals={initVals} validation={fieldValidation} submit={onSubmit}>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLEFIRSTNAME"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="FIRST NAME"
            name="firstName"
            type="text"
            variant={inputVariant}
            placeholder="First Name"
            isOptional={false}
          />
        </div>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLELASTNAME"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="LAST NAME"
            name="lastName"
            type="text"
            variant={inputVariant}
            placeholder="Last Name"
            isOptional={false}
          />
        </div>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLEEMAIL"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="EMAIL"
            name="email"
            type="email"
            variant={inputVariant}
            placeholder="Email"
            isOptional={false}
          />
        </div>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLEPHONENUMBER"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="PHONE NUMBER"
            name="phoneNumber"
            type="text"
            variant={inputVariant}
            placeholder="Phone Number"
            isOptional={false}
          />
        </div>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLECOMPANY"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="ORGANIZATION"
            name="company"
            type="text"
            variant={inputVariant}
            placeholder="Organization"
            isOptional={false}
          />
        </div>
        <div className={Styles.formRow}>
          <InputSelect label="Role" name="role" list={listOfRoles} />
        </div>
        <div className={Styles.formRow}>
          <TextField
            ascope="FORMS"
            adata="FIELDS.ROLEMESSAGE"
            className={css(Styles.input, inputStyle)}
            theme={theme}
            color={color}
            label="MESSAGE"
            name="message"
            type="text"
            variant={inputVariant}
            placeholder="Message"
            isOptional={false}
            isTextarea
          />
        </div>
        <div className={Styles.formRow}>
          <InputCheckbox name="isSignUp" message="Sign up for our newsletter" />
        </div>
        <Button
          ascope="FORMS"
          adata="FIELDS.SUBMIT"
          className={css(Styles.submit)}
          theme={theme}
          color={color}
          hoverColor={hoverColor}
          type="submit"
          displayCTA
        >
          <div className={Styles.ctaCopy}>Submit</div>
        </Button>
      </FormWrapper>
      {success === SUBMIT.FAIL && <p className={Styles.fail}>{CONTACT.ERROR}</p>}
      {success === SUBMIT.CAPTED && <p className={Styles.fail}>{CONTACT.CAPTED}</p>}
    </div>
  )
}

export default EventForm
